module.exports = __webpack_public_path__ + "7b131ab3ceaf55696b688d2617f21f54.svg";